import { useBillingContext } from '@shared/scenes/billing';

export function useCanViewCollectionView() {
  const { billing } = useBillingContext();

  return billing.isPaidPlan !== false;
}
